import { render, staticRenderFns } from "./ReportAssessmentTopIdea.vue?vue&type=template&id=d0b55850&scoped=true"
import script from "./ReportAssessmentTopIdea.vue?vue&type=script&lang=js"
export * from "./ReportAssessmentTopIdea.vue?vue&type=script&lang=js"
import style0 from "./ReportAssessmentTopIdea.vue?vue&type=style&index=0&id=d0b55850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b55850",
  null
  
)

export default component.exports